import React from 'react';
import { aboutUs } from '../data';
import { useTranslation } from 'react-i18next';

const Contacts = () => {
  const { t } = useTranslation();
  return (
    <section className="section" id="contact">
      <span className="section-title">{t('sections.contact')}</span>
      <div className="contact">
        <div className="contact-item">
          <h3 className="company-name">{aboutUs.name}</h3>
          <div className="contact-detail">
            <span className="contact-label">{t('company.info.address')}</span>{' '}
            {aboutUs.address}
          </div>
        </div>
        <div className="contact-item">
          <div className="contact-detail">
            <span className="contact-label">{t('company.info.regNr')}</span>{' '}
            {aboutUs.regNr}
          </div>
          <div className="contact-detail">
            <span className="contact-label">{t('company.info.vatNr')}</span>{' '}
            {aboutUs.vatNr}
          </div>
        </div>
        <div className="contact-item">
          <div className="contact-detail">
            <span className="contact-label">{t('company.info.phone')}</span>{' '}
            <a href={`tel:${aboutUs.phone}`}>{aboutUs.phone}</a>
          </div>
          <div className="contact-detail">
            <span className="contact-label">{t('company.info.email')}</span>{' '}
            <a href={`mailto:${aboutUs.email}`}> {aboutUs.email}</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contacts;
